import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { HttpService } from '../../../services/http.service';
import { PriceAgreement } from './interfaces/price-agreement';

const baseURL: string = 'financial/';
const slug: string = 'price-agreements/';

@Injectable({
  providedIn: 'root'
})
export class PriceAgreementsService {

  constructor(private HttpService: HttpService) { }

  get(params: HttpParams) {
    return this.HttpService.get(baseURL + 'read/' + slug, params);
  }

  getOne(id: number) {
    return this.HttpService.get(baseURL + 'read/' + slug + 'one/' + id.toString());
  }

  getEmpty(): PriceAgreement {
    return {
      id: 0,
      subject_type: null,
      subject_id: 0,
      description: '',
      valid_from: '',
      valid_to: null,
      blocked: false,
      rules: []
    };
  }

  create(data: PriceAgreement) {
    return this.HttpService.post(baseURL + 'create/' + slug, data);
  }

  update(data: PriceAgreement) {
    return this.HttpService.post(baseURL + 'update/' + slug, data);
  }

  delete(id: number) {
    return this.HttpService.get(baseURL + 'delete/' + slug + id.toString());
  }
}
